// Process.jsx
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaBoxOpen, FaTruck, FaCheckCircle } from 'react-icons/fa';
import { PROCESS } from '../../data/siteData';
import './Process.css';

const ICONS = [FaMapMarkerAlt, FaBoxOpen, FaTruck, FaCheckCircle];

export default function Process() {
  return (
    <section className="section process">
      <div className="container">
        <div className="process__head">
          <p className="eyebrow">How Booking Works</p>
          <h2 className="section-title">From Pickup To<br />Safe Delivery.</h2>
        </div>

        <div className="process__track">
          <div className="process__line">
            <motion.div
              className="process__line-fill"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 1.4, ease: 'easeInOut' }}
            />
            <motion.div
              className="process__truck"
              initial={{ left: '0%' }}
              whileInView={{ left: '96%' }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 1.4, ease: 'easeInOut' }}
            >
              <FaTruck />
            </motion.div>
          </div>

          <div className="process__steps">
            {PROCESS.map((p, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  className="process__step"
                  key={p.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-60px' }}
                  transition={{ duration: 0.5, delay: i * 0.15 }}
                >
                  <div className={`process__icon process__icon--${i + 1}`}>
                    <Icon />
                  </div>
                  <h4>{p.title}</h4>
                  <p>{p.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}